<template>
	<aside :class="classes">
		<component :is="'playbooks-' + upsell.icon" class="playbook-upsell__image" />
		<div class="playbook-upsell__text">
			<div class="playbook-upsell__text__heading">
				{{ upsell.heading }}
			</div>
			<div class="playbook-upsell__text__desc">
				{{ upsell.desc }}
			</div>
		</div>
		<div class="playbook-upsell__right">
			<a :href="linkURL" class="playbook-upsell__right__cta" target="_blank">
				<component :is="'playbooks-' + upsell.ctaIcon" v-if="upsell.ctaIcon" :class="upsell.ctaIcon" />
				{{ upsell.linkText }}
			</a>
		</div>
	</aside>
</template>

<script>
export default {
	props: {
		upsell: {
			type: Object,
			required: true,
		},
	},
	computed: {
		/**
		 * Generates classes for the upsell.
		 *
		 * @returns {string} The compiled string
		 */
		classes() {
			// Format slug from camel to kebab case.
			const slug = this.upsell.slug.replace(/[A-Z]/g, '-$&').toLowerCase();

			return `playbook-upsell ${slug}`;
		},
		/**
		 * Generates the URL for the current upsell.
		 *
		 * @returns {string} The URL to use
		 */
		linkURL() {
			const url = this.$urls.marketing(
				'doneForYou' === this.upsell.slug ? 'gift-campaign-request/' : 'vip-service/'
			);

			return this.$urls.utmLink(url, {
				utm_medium: 'Playbooks',
			});
		},
	},
};
</script>

<style lang="scss">
.playbook-upsell {
	background: #f3f9fe;
	border: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 2px !important;
	padding-left: 30px !important;
	padding-right: 40px !important;
	padding-top: 21px !important;

	@media screen and (max-width: 1055px) {
		width: 120px;
	}

	@media screen and (max-width: 1200px) {
		flex-direction: column;
	}

	&.container {
		width: auto;
		padding-bottom: 2px;
		padding-left: 30px;
		padding-right: 40px;
		padding-top: 21px;
		margin-bottom: 30px;
	}

	&__image {
		margin-right: 19px;
		width: 100px;
		height: auto;

		@media screen and (max-width: 1200px) {
			margin: 0 0 10px 0;
		}
	}
	&__text {
		margin-right: 0;
		margin-bottom: 21px;
		flex: 1 1;
		text-align: left;
		&__heading {
			font-size: 20px;
			font-weight: 700;
			line-height: 1.3em;

			@media screen and (max-width: 1200px) {
				font-size: 16px;
				text-align: center;
			}
		}
		&__desc {
			font-size: 18px;
			line-height: 1.3em;
			font-weight: 400;

			@media screen and (max-width: 1200px) {
				font-size: 12px;
				text-align: center;
			}
		}
	}
	&__right {
		margin-right: 0;
		margin-bottom: 21px;
		font-size: 18.5px;
		line-height: 1.5em;
		text-align: right;
		padding-left: 10px;

		&__cta {
			background: #0d82df;
			border-radius: 3px;
			padding: 10px 25px;
			font-size: 16px;
			color: #fff !important;
			display: inline-flex;
			align-items: center;
			line-height: 1em;
			font-weight: 600;

			&:hover {
				color: #fff;
			}
		}
		svg {
			margin-right: 7px;
			vertical-align: sub;

			&.svg-available {
				circle {
					stroke: #fff;
				}
				path {
					fill: #fff;
				}
			}
		}
	}
}

// Fix spacing issues due to the taller svg used.
.done-for-you {
	padding-top: 3px;

	.upsell-text,
	.upsell-right {
		margin-bottom: 0;
	}
}

// The hire expert icon is slightly wider than the baseline.
.hire-expert {
	.upsell-image {
		width: 110px;
	}
}
</style>
